// Summary exports — capture the rendered Option-A cards (total / type bars / hazard pills /
// per-unit) as an image and lay it into a PDF or PPTX, so the customer gets the same
// formatting as on screen. CSV stays a separate data export in index.jsx.

const capture = async (node) => {
  const html2canvas = (await import('html2canvas')).default
  return html2canvas(node, { useCORS: true, backgroundColor: '#ffffff', scale: 2, logging: false })
}

export const exportSummaryPdf = async (node, meta = {}) => {
  if (!node) return
  const { jsPDF } = await import('jspdf')
  const canvas = await capture(node)
  const doc = new jsPDF({ unit: 'pt', format: 'a4' })
  const W = doc.internal.pageSize.getWidth()
  const H = doc.internal.pageSize.getHeight()
  let y = 44
  doc.setFont('helvetica', 'bold'); doc.setFontSize(18); doc.text('Alert Summary', 40, y); y += 22
  doc.setFont('helvetica', 'normal'); doc.setFontSize(11)
  if (meta.subtitle) { doc.text(meta.subtitle, 40, y); y += 16 }
  if (meta.company) { doc.text(`Group: ${meta.company}`, 40, y); y += 16 }
  doc.text(`Generated by ${meta.user || 'unknown'} on ${meta.date || ''}`, 40, y); y += 18
  const w = W - 80
  const h = (canvas.height / canvas.width) * w
  doc.addImage(canvas.toDataURL('image/png'), 'PNG', 40, y, w, Math.min(h, H - y - 40))
  doc.save(`${meta.file || 'alert_summary'}.pdf`)
}

export const exportSummaryPptx = async (node, meta = {}) => {
  if (!node) return
  const PptxGenJS = (await import('pptxgenjs')).default
  const canvas = await capture(node)
  const pptx = new PptxGenJS()
  const s = pptx.addSlide()
  s.addText('Alert Summary', { x: 0.5, y: 0.3, fontSize: 24, bold: true })
  const header = [meta.subtitle, meta.company ? `Group: ${meta.company}` : null].filter(Boolean).join('  ·  ')
  if (header) s.addText(header, { x: 0.5, y: 0.95, fontSize: 12, w: 9 })
  const w = 8.5
  const h = (canvas.height / canvas.width) * w
  s.addImage({ data: canvas.toDataURL('image/png'), x: 0.5, y: 1.4, w, h: Math.min(h, 5.2) })
  await pptx.writeFile({ fileName: `${meta.file || 'alert_summary'}.pptx` })
}
